import React from "react";
import { Plus, MapPin, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ExhibitionCountry } from "@/hooks/useExhibition";

interface ExhibitionEmptyCountryStateProps {
  country: ExhibitionCountry;
  onCreateBooth?: () => void;
  onEnterCustomCity?: () => void;
}

const ExhibitionEmptyCountryState: React.FC<ExhibitionEmptyCountryStateProps> = ({
  country,
  onCreateBooth,
  onEnterCustomCity
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6">
      {/* Icon */}
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
        <Sparkles className="w-8 h-8 text-primary" />
      </div>

      {/* Country Flag */}
      <div className="text-4xl mb-3">{country.flag}</div>

      {/* Heading */}
      <h2 className="text-lg font-bold text-center mb-2">
        Be the first in {country.name}!
      </h2>

      {/* Subtext */}
      <p className="text-muted-foreground text-center text-sm max-w-xs mb-6">
        No booths yet. Start a booth in any city and be the pioneer!
      </p>

      {/* Action Buttons */}
      <div className="space-y-3 w-full max-w-xs">
        {/* Primary CTA */}
        {onEnterCustomCity && (
          <Button
            onClick={onEnterCustomCity}
            className="w-full gap-2 bg-gradient-to-r from-primary to-primary/80"
          >
            <MapPin className="w-4 h-4" />
            Enter a City
          </Button>
        )}
        
        {onCreateBooth && (
          <Button
            onClick={onCreateBooth}
            variant="outline"
            className="w-full gap-2"
          >
            <Plus className="w-4 h-4" />
            Create First Booth
          </Button>
        )}
      </div>
    </div>
  );
};

export default ExhibitionEmptyCountryState;
